const vndFormat = new Intl.NumberFormat("vi-VN", {
  style: "currency",
  currency: "VND",
});

export default vndFormat;
